var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications-item-base',{attrs:{"title":_vm.notification.title,"read":_vm.notification.read,"body":_vm.notification.body,"time":_vm.notification.time,"notification-id":_vm.notification.id,"icon":"fa-solid fa-comment","color":"blue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }